module.exports = __webpack_public_path__ + "c2a0568c0e7e50a6dc736901d3468e47.svg";